export default "__VITE_ASSET__DX5Oohgu__"